import { render, staticRenderFns } from "./DocumentVersionsDlg.vue?vue&type=template&id=5d17bd1d&"
import script from "./DocumentVersionsDlg.vue?vue&type=script&lang=js&"
export * from "./DocumentVersionsDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports